import React from 'react';
import { Smiley, SmileyMeh, SmileySad } from 'phosphor-react';
import { StepReaction } from '../../types/enums';

interface ReactionConfig {
  label: string;
  icon: React.ReactNode;
  color: string;
}

const REACTION_CONFIG: Record<string, ReactionConfig> = {
  GREAT:     { label: 'Ótimo',   icon: <Smiley className="w-3.5 h-3.5" />, color: 'text-sage-600 dark:text-sage-400'  },
  NEUTRAL:   { label: 'Neutro',  icon: <SmileyMeh   className="w-3.5 h-3.5" />, color: 'text-nude-500 dark:text-gray-400'  },
  IRRITATED: { label: 'Irritou', icon: <SmileySad className="w-3.5 h-3.5" />, color: 'text-red-500 dark:text-red-400'    },
};

interface ReactionBadgeProps {
  reaction?: StepReaction | string | null;
}

export default function ReactionBadge({ reaction }: ReactionBadgeProps) {
  if (!reaction) return null;
  const cfg = REACTION_CONFIG[reaction];
  if (!cfg) return null;

  return (
    <span className={`flex items-center gap-1 text-[11px] font-medium ${cfg.color}`}>
      {cfg.icon} {cfg.label}
    </span>
  );
}
